import React from "react";

export default function CustomeCategoryandSubcategory({ posts, showcate = false }) {

  return (
    <div className="lang-sec price-duration align-items-start flex-column">
      {posts?.category_title ?
        <>
          <h6>{posts?.industry_title && <>Industry,</>} Category   {posts?.sub_category_title ? '& Subcategory' : ''}</h6>
          {posts?.industry_title ? <p>Industry : {posts?.industry_title}</p> : ''}
          <p> {showcate == true ? '' : 'Category :'}  {posts?.category_title}</p>
          {posts?.sub_category_title ? <p>Subcategory : {posts?.sub_category_title}</p> : ''}
        </>
        :
        ''
      }
    </div>
  );
}
